import React from "react";
import "../../Styles/landing.css";

export default function Footer() {
  return (
    <footer className="Rodape">
      <p>
        <a
          target="blank"
          href="https://github.com/Gabriel200395/github-profiles"
        >
          Veja o código deste projeto clicando aqui
        </a>
      </p>
      <a target="blank" href="https://github.com/Gabriel200395">
        Feito por : Gabriel Souza
      </a>
    </footer>
  );
}
